module.exports = __webpack_public_path__ + "img/eat_out_21.9892a9db.jpg";